<template>
  <div class="home">
    <Calculator2 />
  </div>
</template>

<script>
import Calculator2 from "../components/Calculator2.vue";
export default {
  name: "HomeView",
  components: { Calculator2 },
};
</script>
